import { getNewPasswordSchema } from "Schemas/passwordSchema";
import { Resources, type TFunction } from "Translations/Resources";
import { z } from "zod";

const VALIDATION_RESOURCES = Resources.Components.UserAccount.ChangePassword;

/**
 * Cross-field password rules shared by the Zod schema (submit gating) and the
 * live checklist (visual feedback) so the two can't drift. The checklist layer
 * adds its own "has the user typed yet" guard on top of these predicates.
 */
export const isNewPasswordDifferentFromOld = (
  newPassword: string,
  oldPassword: string,
) => newPassword !== oldPassword;

export const doNewPasswordsMatch = (
  newPassword: string,
  newPasswordConfirm: string,
) => newPassword === newPasswordConfirm;

export const getChangePasswordValidationSchema = (t: TFunction) =>
  z
    .object({
      oldPassword: z.string().min(1, t(Resources.Validation.Required)),
      newPassword: getNewPasswordSchema(t),
      newPasswordConfirm: z.string().min(1, t(Resources.Validation.Required)),
    })
    .refine(
      (data) => doNewPasswordsMatch(data.newPassword, data.newPasswordConfirm),
      {
        message: t(Resources.Validation.Password.Match),
        path: ["newPasswordConfirm"],
      },
    )
    .refine(
      (data) =>
        isNewPasswordDifferentFromOld(data.newPassword, data.oldPassword),
      {
        message: t(VALIDATION_RESOURCES.NewMustDiffer),
        path: ["newPassword"],
      },
    );

export type ChangePasswordFormModel = z.infer<
  ReturnType<typeof getChangePasswordValidationSchema>
>;
